import { OrderItemModel } from "./OrderItemModel";
import { PaymentModel } from "./PaymentModel";

export class OrderModel {
  id: string;
  companyCode: string;
  storeCode: string;
  moduleId?: string;
  moduleName?: string;
  customerId?: string;
  cashId?: string;
  status: string;
  subtotal: number;
  discountType?: string;
  discountValue: number;
  total: number;
  paymentMethod?: string;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
  items: OrderItemModel[];
  payments: PaymentModel[];
  hasStation: boolean;
  fiscalNumber: string;

  constructor(data: Partial<any> = {}) {
    this.id = data.id;
    this.companyCode = data.companyCode;
    this.storeCode = data.storeCode;
    this.moduleId = data.moduleId;
    this.moduleName = data.moduleName;
    this.customerId = data.customerId;
    this.cashId = data.cashId;
    this.status = data.status;
    this.subtotal = Number(data.subtotal);
    this.discountType = data.discountType;
    this.discountValue = Number(data.discountValue ?? 0);
    this.total = Number(data.total);
    this.paymentMethod = data.paymentMethod ?? null;
    this.notes = data.notes ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.items = Array.isArray(data.items)
      ? data.items.map((item) => new OrderItemModel(item))
      : [];
    this.payments = Array.isArray(data.payments)
      ? data.payments.map((pay) => new PaymentModel(pay))
      : [];
    this.hasStation = data.hasStation;
    this.fiscalNumber = data.fiscalNumber;
  }
}
